import React, {useContext, useEffect} from 'react';
import {Button} from 'antd';
import DeleteComponent from '../common/DeleteComponent';
import {Arguments} from '../common/Arguments';
import {sideMenuContext} from '../../../router/IndexRouter';
import {GetApiMethod} from '../common/ApiMethod';
import TableComponent from '../common/TablePaginationComponent';
import {aesEncrypt} from '../common/EncodeDecodeMethod';
import {handleResetPassword, updateUserDB} from '../common/ChangeAndUpdatePassword';
import SearchBox from '../common/SearchBoxComponent';

export default function Users(props) {
	const {dataSource, setDataSource, setCopyDataSource, setCurrentItem} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/policy/api!allUsers.do';

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const resetPassword = (item) => {
		// 向用户中心发送修改密码的请求
		const nickname = item.nickname;
		const userName = item.userName;
		const newPassword = '123qweAS';
		handleResetPassword(nickname, userName, newPassword).then(res => {
			if (res?.data.code === '1') {
				// 更新 user_info 表中的数据
				const objData = {...item, password: aesEncrypt(newPassword)};
				updateUserDB(objData);
				// 重新请求 user_info 的数据更新列表，如果再次点击同一个用户，则使用的是最新数据
				setTimeout(() => {
					GetApiMethod({getApi, setDataSource, setCopyDataSource});
				}, 500);
			}
		});

	};

	const editUser = (item) => {
		setCurrentItem(item);
		props.history.push('/private/users/edit');
	};

	const changeName = (item) => {
		setCurrentItem(item);
		props.history.push('/private/users/changeName');
	};

	const columns = [
		{
			title: '序号',
			dataIndex: 'showIndex',
			width: 140,
			sorter: (a, b) => a.showIndex - b.showIndex,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '用户名',
			responsive: ['lg'],
			dataIndex: 'nickname',
		},
		{
			title: '角色',
			dataIndex: 'role',
		},
		{
			title: '显示序号',
			dataIndex: 'showFlag',
			width: 200,
		},
		{
			title: '操作',
			width: 360,
			render: (item) => (
				<>
					<Button type="link"
							onClick={() => editUser(item)}
							style={{color: 'green'}}
					>编辑</Button>
					<Button type="link"
							onClick={() => changeName(item)}
							style={{color: 'orange'}}
					>修改用户名</Button>
					<Button type="link" onClick={() => resetPassword(item)}>重置密码</Button>
					<DeleteComponent
						item={item}
						postApi={[Arguments.host + '/society_organization/policy/api!deleteUser.do']}
						getApi={getApi}
					/>
				</>
			),
		},
	];

	const noAdminData = dataSource.filter(user => user.organizationId !== '1000');
	const indexDataSource = noAdminData.map((data, index) => ({showIndex: index + 1, ...data}));

	return (
		<>
			<Button type="primary" onClick={() => props.history.push('/private/users/add')}
					style={{marginBottom: 10}}>新增用户</Button>
			<SearchBox placeholder="请输入用户名关键字"/>
			<TableComponent dataSource={indexDataSource} columns={columns}/>
		</>
	);
}


